import { COLORS, FONTS } from "../constants/theme";

// ─── PRICING CARD ─────────────────────────────────────────────────────────────
// A single pricing tier card. Used in the marketing site pricing section.
//
// Usage:
//   <PricingCard tier={PRICING[1]} onCta={() => navigate("signup")} />

export default function PricingCard({ tier: p, onCta }) {
  return (
    <div className={`pricing-card${p.popular ? " popular" : ""}`} style={{ maxWidth: 320 }}>
      {p.popular && (
        <div
          style={{
            background: `linear-gradient(90deg, ${COLORS.iqBlue}, ${COLORS.iqBlueMid})`,
            borderRadius: 6,
            padding: "3px 10px",
            fontSize: 11,
            fontFamily: FONTS.mono,
            color: "#fff",
            display: "inline-block",
            marginBottom: 16,
          }}
        >
          Most popular
        </div>
      )}

      <h3 style={{ fontFamily: FONTS.display, fontWeight: 700, fontSize: 22, marginBottom: 8, color: COLORS.textPrimary }}>
        {p.name}
      </h3>
      <p style={{ color: COLORS.textSecondary, fontSize: 13, marginBottom: 24, lineHeight: 1.6 }}>
        {p.desc}
      </p>

      <div style={{ marginBottom: 28 }}>
        {p.price ? (
          <>
            <span style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 40, letterSpacing: "-.04em", color: COLORS.textPrimary }}>
              ${p.price}
            </span>
            <span style={{ color: COLORS.textSecondary, fontSize: 13 }}>/{p.period}</span>
          </>
        ) : (
          <span style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 32, letterSpacing: "-.03em", color: COLORS.textPrimary }}>
            Custom
          </span>
        )}
      </div>

      <div style={{ marginBottom: 28 }}>
        {p.features.map((f, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <span style={{ color: COLORS.iqBlueMid, fontSize: 14 }}>✓</span>
            <span style={{ fontSize: 13, color: "#a0aec0" }}>{f}</span>
          </div>
        ))}
      </div>

      <button
        className={p.popular ? "btn-primary" : "btn-ghost"}
        style={{ width: "100%", textAlign: "center" }}
        onClick={onCta}
      >
        {p.cta}
      </button>
    </div>
  );
}
